import React, { useState, useEffect } from "react";
import lottie from "lottie-web";
import { useRef } from "react";
import { useHistory } from "react-router-dom";

import AppScreen from "./AppScreen";
import { SearchIcon } from "./Icons";

import { useDispatch } from "react-redux";
import { getCoursesAsync } from "../redux/coursesReducer";

export const HeroSection = () => {
  const history = useHistory();
  const [search, setSearchInput] = useState("");

  const handleSearch = (e) => {
    setSearchInput(e.target.value);
  };

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(`/courses?name[options]=i&name[regex]=${search}&page=1`);
    dispatch(
      getCoursesAsync(`/courses?name[options]=i&name[regex]=${search}&page=1`)
    );
  };

  const container = useRef(null);

  const mounted = useRef();
  useEffect(() => {
    if (mounted.current !== true) {
      lottie.loadAnimation({
        name: "confetti",
        container: container.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: "https://assets5.lottiefiles.com/packages/lf20_hzfmxrr7.json",
      });
      mounted.current = true;
    }
  });

  return (
    <AppScreen>
      <div className="mx-6 sm:mx-16 mt-40 lg:ml-16 lg:mt-64">
        <form
          onSubmit={(e) => handleSubmit(e)}
          className="text-white text-4xl sm:text-6xl font-extrabold mt-14 mb-14"
        >
          Find the courses you need.
          <p className="text-xs sm:text-lg text-gray-300 font-semibold mt-5">
            While you focus on learning, we'll find your ideal course.
          </p>
          <div className="flex items-center mt-4 mb-4 h-16">
            <div className=" text-2xl left-5 px-5 rounded-l-md h-full bg-white flex justify-center items-center text-black">
              <SearchIcon />
            </div>
            <input
              autoFocus={true}
              name="search"
              type="text"
              className="container rounded-r-md font-bold  bg-white text-black h-full w-full lg:w-1/2 text-lg outline-none block"
              value={search}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <button
            type="submit"
            className="p-3 rounded-lg bg-white text-lg transform transition-all focus:translate-y-0 hover:-translate-y-1 border-2  font-bold block sm:inline-block w-full sm:w-32  duration-200"
          >
            <div className="bg-gradient-to-br from-indigo-600 to-red-500 text-transparent bg-clip-text">
              Go!
            </div>
          </button>
          <button
            type="submit"
            className="p-3 rounded-lg transform transition-all focus:translate-y-0 hover:-translate-y-1 text-white border-2 border-white text-lg ml-0 sm:ml-4 sm:inline-block w-full sm:w-32 mt-4 sm:mt-0 hover:border-indigo-200 hover:text-indigo-200  duration-200"
          >
            All Courses
          </button>
        </form>
        <div
          className="hero-animation static mx-auto mt-5 sm:absolute sm:transform translate-x-1/2 right-1/2 lg:transform-none lg:right-10 bottom-5 w-full sm:w-1/2 lg:w-1/3 pointer-events-none"
          ref={container}
        ></div>
      </div>
    </AppScreen>
  );
};
